import React from 'react';
import PropTypes from 'prop-types';
import styles from './RadioButton-hashed.scss';
import cx from 'classnames';
import {isEmptyValue, isNilValue} from '../fieldValues';
import defaultTranslator from '@elixir/translator';

export class RadioButton extends React.Component {

    static propTypes = {
        /**
         * Theme to apply to component
         */
        theme: PropTypes.object,
        /**
         * Radio Button Options
         */
        option: PropTypes.object,
        /**
         * Is this field disabled?
         */
        disabled: PropTypes.bool,
        /**
         * Value to determine is the button checked ot unchecked 
         */
        value: PropTypes.string,
        /**
         * Is this field required?
         */
        required: PropTypes.bool,
        /**
         * Id of the radio button
         */
        id: PropTypes.string,
        /**
         * Callback when the value is changed
         */
        onValueChange: PropTypes.func
    };


    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    inputRef = React.createRef();

    handleKeyDown = (evt) => this.props.onKeyDown(evt, this.inputRef);

    handleValueChange = (evt) => {
        const {onValueChange} = this.props;

        if (onValueChange) {
            onValueChange(evt.target.value);
        }
    };

    handleKeyDown = (evt) => {
        const {onValueChange} = this.props;
        
        if (evt.key === ' ') { // spacebar
            if (onValueChange) {
                onValueChange(this.inputRef.current.value);
            }
            evt.preventDefault(); // disable scrolling with spacebar
        }
    };

    render() {
        const { 
            id, theme, option, value, disabled, required, onValueChange, textAlign, controlClassName, ...other
        } = this.props;

        const themeStyles = (theme) ? theme.getStyles('RadioButton', styles) : styles;
        const classes = cx(themeStyles.radioButton, controlClassName);
        const translator = this.context.translator || defaultTranslator;
        let code = option.code;
        let checked = (!isNilValue(value) && value.toString() === option.code);

        if (isNilValue(option.code)) {
            code = 'empty';
            checked = isEmptyValue(value);
        }         

        let primaryText;
        if (option.name) {
            primaryText = 
                <span className={themeStyles.primaryText} > 
                    {translator(option.name)}
                </span>;
        }

        let secondaryText;
        if (option.subtitle) {
            secondaryText = 
                    <span className={themeStyles.secondaryText}> 
                        {translator(option.subtitle)}
                    </span>;
        }

        const valueId = `${id}_${code}`;
        const tabIndex = disabled ? undefined : 0;

        return (<div className={classes}>
            <input
                type="radio"
                id={valueId} value={option.code || ''}
                onChange={this.handleValueChange}
                checked={checked}
                disabled={disabled}
                required={required}
                ref={this.inputRef}
                {...other}
            />
            <label
                role="radio" 
                htmlFor={valueId} 
                aria-checked={checked} 
                onKeyDown={this.handleKeyDown}
                tabIndex={tabIndex} 
                className={themeStyles.label}>
                {primaryText}
                {secondaryText}
            </label>
        </div>);
    } 
}

// this is an unthemed component, which is expected to be used in a themed component that passes the current theme
export default RadioButton;
